type SymbolMap = Record<
    string,
    {
        htmlCode: number
        className?:
            | 'superscript'
            | 'subscript'
            | 'magnifyingGlass'
            | 'large-superscript'
            | 'plus-subscript'
    }
>

// Format: 'unicode': { htmlCode: ..., className: ... }
export const SYMBOL_MAP: SymbolMap = {
    '030D': { htmlCode: 781, className: 'large-superscript' },
    '002A': { htmlCode: 42 },
    '02D6': { htmlCode: 726, className: 'plus-subscript' },
    '030E': { htmlCode: 782, className: 'superscript' },
    '033E': { htmlCode: 830, className: 'superscript' },
    '0351': { htmlCode: 849, className: 'superscript' },
    '030A': { htmlCode: 778, className: 'superscript' },
    '02C6': { htmlCode: 710 },
    '033D': { htmlCode: 829, className: 'superscript' },
    '0342': { htmlCode: 834, className: 'superscript' },
    '034C': { htmlCode: 844, className: 'superscript' },
    '034B': { htmlCode: 843, className: 'superscript' },
    '00AE': { htmlCode: 174 },
    '0595': { htmlCode: 1429 },
    '05A0': { htmlCode: 1440, className: 'magnifyingGlass' },
    '0346': { htmlCode: 838, className: 'superscript' },
    '035B': { htmlCode: 859, className: 'superscript' },
    '2311': { htmlCode: 8977 },
    '02C5': { htmlCode: 709 },
    '0F1B': { htmlCode: 3867, className: 'subscript' },
    '0F1C': { htmlCode: 3868 },
    '0FCF': { htmlCode: 4047 },
    '2035': { htmlCode: 8245 },
    '2036': { htmlCode: 8246 },
    '2037': { htmlCode: 8247 },
    '0592': { htmlCode: 1426 },
    '02B1': { htmlCode: 689 },
    '0350': { htmlCode: 848 },
    '030C': { htmlCode: 780 },
    '02DF': { htmlCode: 735 },
}
